import { SERVICE_FUNCTION_TO_FEATURE } from "../config";
import Chip from '@mui/material/Chip';
import {
  PERMISSIONS, IAM_USER_POLICY_ALL_RESOURCES_KEY, IAM_USER_POLICY_ID_KEY,
  IAM_USER_POLICY_TYPE_KEY, IAM_USER_POLICY_VESSEL_NAME_KEY,CAPTIVE_ACCESS_ENABLED,
  IAM_USER_POLICY_VESSEL, IAM_USER_POLICY_ALL_RESOURCES_VALUE, USER_OU, USER_PREFERENCES, NEWINTERVALS, getLastThreeMonth
} from '../constants/Constants';
import {
    SIDE_MENU_ITEM_ACCOUNT_MANAGEMENT, SIDE_MENU_ITEM_ALERTS,
    SIDE_MENU_ITEM_DASHBOARD, SIDE_MENU_ITEM_MAP,
    SIDE_MENU_ITEM_TICKETS, SIDE_MENU_ITEM_SOFTWARE_LISTING, SIDE_MENU_ITEM_SIM_REPORTS,
    SIDE_MENU_ITEM_AUDIT_LOGS,SIDE_MENU_ITEM_INVENTORY,
    SIDE_MENU_ITEM_KNOWLEDGE_CENTER,
    SIDE_MENU_ITEM_GEO_MANAGEMENT,KONTROL_MANAGEMENT,

    KNOWLEDGE_CENTER, SIDE_MENU_ITEM_STARLINK, SIDE_MENU_ITEM_QUOTA_MANAGEMENT, SIDE_MENU_ITEM_TRENDS, SIDE_MENU_ITEM_HUB, HUB, SIDE_MENU_ITEM_CONTENT_FILTER, SIDE_MENU_ITEM_CYBER, CYBER, SIDE_MENU_ITEM_CAPTIVE, SIDE_MENU_ITEM_TOPOLOGY,
    SIDE_MENU_ITEM_ANALYTICS, SIDE_MENU_ITEM_DATA_NAVIGATOR

} from "./constants";
import SidebarNavCategoryIcon from "../asset/image/SideNavCategoryIcon.svg";
import StandardIcon from "../asset/image/standard.svg"
import SidebarNavNotificationIcon from "../asset/image/SideNavNotificationIcon.svg";
import SidebarNavMapIcon from "../asset/image/SideNavMapIcon.svg";
import SidebarNavNotesIcon from "../asset/image/SideNavNotesIcon.svg";
import SidebarNavUserIcon from "../asset/image/SideNavUserIcon.svg";
import SidebarNavTicketsIcon from "../asset/image/SideNavTicketsIcon.svg";
import SidebarNavDescription from "../asset/image/SideNavDescription.svg";
import SideNavSwConfigIcon from "../asset/image/SideNavSwConfigIcon.svg";
import SideNavAnalytics from "../asset/image/analytics.svg";
import SideNavDataNavigator from "../asset/image/SideNavDataNavigator.svg";

import SideNavKnowledgeCenter from "../asset/image/SideNavKnowledgeCenter.svg";
import SideNavCaptive from "../asset/image/SideNavCaptive.svg";
import TopologyIc from "../asset/image/TopologyIc.svg"
import SideNavStarlink from "../asset/image/SideNavStarlink.svg";
import SideNavContentFilter1 from "../asset/image/SideNavContentFilter1.svg";
import SideNavQuotaControl from "../asset/image/SideNavQuotaControl.svg";
import SideNavInventory from "../asset/image/SideNavInventory.svg";
import _ from "lodash";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import moment from "moment-timezone";
import { UPDATE_NEW_SUMMARY_END_DATE, UPDATE_NEW_SUMMARY_START_DATE ,LIMITED_REPORT_ACCESS,SITE_ADMIN_ACCESS,SL_ADMIN_ACCESS} from "../actions/types";
import {customUnit} from "../../src/config";
import Highcharts from "highcharts";
import { approximateDateRange } from "../actions/Users/authenticateUsageReports";

const T0_TIER = "T0"
const T101_TIER = "T101"
const T91_TIER = "T91"

export const getConfigServiceFunctionLabel = (key: string) => {
  if (SERVICE_FUNCTION_TO_FEATURE && SERVICE_FUNCTION_TO_FEATURE[key]) {
    return SERVICE_FUNCTION_TO_FEATURE[key]
  }
  return null;
}

export const getServiceFunctionResources = (permissions: any[], serviceFunctionConfig: any) => {
  if (permissions && Array.isArray(permissions) && serviceFunctionConfig && serviceFunctionConfig.service && serviceFunctionConfig.function) {
    const _service = permissions.find(o => o.service === serviceFunctionConfig.service);
    if (_service) {
      let _serviceFunction = _service.servicefunctions.find(o => o.function === serviceFunctionConfig.function);
      if (_serviceFunction && _serviceFunction.resources) {
        return _serviceFunction.resources;
      }
    }
  }
  return [];
}

export const checkLoggedInUserAuthorizedToViewPage = (permissionKey: any, serviceFunctionKey: any) => {
  let allVesselsCheck = false;
  let serviceFunctionAvailable = getServiceFunction(permissionKey, serviceFunctionKey, allVesselsCheck);
  if (serviceFunctionAvailable) {
    return true;
  }
  return false;
}

/*
* Returns service function data i.e {"function":serviceFunctionKey,"resources":[]} if exists else returns null
*/
export const getServiceFunction = (permissionKey: any, serviceFunctionKey: any, allVesselsCheck = true) => {
  // get filtered all_resources list
  let filteredAllVessels = allVesselsCheck && getFilteredAllVessels();
  // get permissions from local storage 
  let localStorageData = getDataFromLocalStorage(PERMISSIONS);
  if (localStorageData) {
    // Data is stored as key/value pairs of strings, so parse it
    let parsedData = JSON.parse(localStorageData);
    if (permissionKey && parsedData && Array.isArray(parsedData) && parsedData.length > 0) {
      // get permissionKey data
      let permission = parsedData.find(o => o.service.trim() === permissionKey.trim());
      if (serviceFunctionKey && permission && permission.servicefunctions && Array.isArray(permission.servicefunctions)) {
        // get serviceFunctionKey data
        let serviceFunctionData = permission.servicefunctions.find(o => o.function.trim() === serviceFunctionKey.trim());
        if (allVesselsCheck) {
          return performAllVesselsCheck(serviceFunctionData, filteredAllVessels);
        } else {
          return serviceFunctionData;
        }
      }
    }
  }
  return null;
}

const getFilteredAllVessels = () => {
  // get all_resources from local storage
  let allVessels:any = getDataFromLocalStorage(IAM_USER_POLICY_ALL_RESOURCES_KEY);
  try {
    return JSON.parse(allVessels);
  }
  catch(err) {
    return null;
  }
}

//  To update the site-name after change in topology in local-storage
export const updateLocalSiteName = (siteId: string, siteName: string) => {
  let allVessels = getDataFromLocalStorage(IAM_USER_POLICY_ALL_RESOURCES_KEY);
  if (allVessels) {
    // Data is stored as key/value pairs of strings, so parse it
    let parsedAllVessels = JSON.parse(allVessels);
    if (parsedAllVessels && parsedAllVessels.length > 0) {
      const site = parsedAllVessels.find(res => res.id == siteId);
      if (!site)
        return;
      site.name = siteName;
      setDataToLocalStorage(IAM_USER_POLICY_ALL_RESOURCES_KEY, JSON.stringify(parsedAllVessels));
    }
  }
}

const performAllVesselsCheck = (serviceFunction, filteredAllVessels) => {
  let resources = serviceFunction && serviceFunction.resources;
  if (resources) {
    // check resources has vessel-name: "*" i.e all_resources
    let isAllVessels = resources.find(r => r[IAM_USER_POLICY_VESSEL_NAME_KEY] === IAM_USER_POLICY_ALL_RESOURCES_VALUE);
    if (isAllVessels) {
      serviceFunction.resources = filteredAllVessels;
    } else {
      // consider it as resource if and only if TYPE == VESSEL and ID_KEY,VESSEL_NAME_KEY are present
      serviceFunction.resources = resources.filter(a => a[IAM_USER_POLICY_TYPE_KEY] === IAM_USER_POLICY_VESSEL && a[IAM_USER_POLICY_ID_KEY] && a[IAM_USER_POLICY_VESSEL_NAME_KEY]);
    }
  }
  return serviceFunction;
}

export const getDataFromLocalStorage = (key: any) => {
  return localStorage.getItem(key);
}

export const getLoggedInAuthType = (): "IAM" | "SSO" => {
  const value = getDataFromLocalStorage("authType");
  return value === "SSO" ? "SSO" : "IAM";
}

export const getDataFromLocalStorageParsed = (key: any) => {
  let _data = localStorage.getItem(key) || "";
  try {
    let _parsed = JSON.parse(_data);
    return _parsed;
  } catch (e) {
    return null;
  }
}

export const setDataToLocalStorage = (key: any, value: any) => {
  return localStorage.setItem(key, value);
}

export const removeDataFromLocalStorage = (key: any) => {
  return localStorage.removeItem(key);
}

export const autoCompleteRenderTags = (value: any, limitTags: number, getTagProps, key) => {
  const numTags = value.length;
  return (
    <>
      {value.slice(0, limitTags).map((option, index) => (
        <Chip
          {...getTagProps({ index })}
          key={index}
          label={option[key]}
        />
      ))}
      {numTags > limitTags && ` +${numTags - limitTags}`}
    </>
  );
}

export const formatBytes = (bytes: number, decimals = 2, minUnit?: 'MB'): string => {
  if (!bytes) return minUnit === 'MB' ? `0 MB` : '0 B';
  if (!minUnit && bytes < 1000) return `${bytes} B`;
  if (!minUnit && bytes < 1000 * 1000) return `${(bytes / 1000).toFixed(decimals)} KB`;
  if (bytes < 1000 * 1000 * 1000) return `${(bytes / (1000 * 1000)).toFixed(decimals)} MB`;
  if (bytes < 1000 * 1000 * 1000 * 1000) return `${(bytes / (1000 * 1000 * 1000)).toFixed(decimals)} GB`;
  return `${(bytes / (1000 * 1000 * 1000 * 1000)).toFixed(decimals)} TB`;
};

export const readableBytes = (bytes: any) => {
  let _bytes = bytes;
  if (_bytes <= 0 || isNaN(_bytes)) {
    return "-";
  }
  let i: number = Math.floor(Math.log(_bytes) / Math.log(1024));
  let sizes: string[] = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  return (_bytes / Math.pow(1024, i)).toFixed(2) + ' ' + sizes[i];
}

export const readableBytesFormat = (bytes: any) => {
  let _bytes = bytes;
  if (_bytes <= 0 || isNaN(_bytes)) {
    return "-";
  }
  let i: number = Math.floor(Math.log(_bytes) / Math.log(1000));
  let sizes: string[] = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  return (_bytes / Math.pow(1000, i)).toFixed(2) + ' ' + sizes[i];
}

export const readableBytesAsGB = (bytes: any, appendUnit = true) => {
  const _bytes = Number(bytes);

  if (isNaN(_bytes) || _bytes <= 0) {
    return appendUnit ? '0 GB' : '0';
  }

  const gbValue = _bytes / Math.pow(1000, 3);
  const formatted = gbValue < 1 ? gbValue.toFixed(2) : gbValue.toFixed(2);

  return appendUnit ? `${formatted} GB` : formatted;
};

export const readableBytesAsMB = (bytes: any, appendUnit = true) => {
  let _bytes = bytes;
  if (_bytes <= 0) {
    return appendUnit ? '0 GB' : '0';
  }
  const value = (_bytes / Math.pow(1000, 2)).toFixed(2);
  return appendUnit ? value + ' MB' : value;
}

export const readableBytesAsKB = (bytes: any, appendUnit = true) => {
  let _bytes = bytes;
  if (_bytes <= 0) {
    return appendUnit ? '0 GB' : '0';
  }
  const value = (_bytes / Math.pow(1000, 1)).toFixed(2);
  return appendUnit ? value + ' KB' : value;
}

export const readableBytesToBytes = (readableBytes: string): number => {
  let bytes = 0;
  let unit = readableBytes?.slice(-2)?.trim();
  let value = readableBytes.slice(0, -2);
  let sizes: string[] = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  let index = sizes.indexOf(unit);
  if (index === -1) {
    return bytes;
  }
  bytes = parseFloat(value) * Math.pow(1000, index);
  return bytes;
}

export const toCustomUnit = (val: any) => {
    if(customUnit == "Bytes"){
      return val??0;
    }else if(customUnit == "KB"){
      return readableBytesAsKB(val).replace( " KB", "")
    }else if(customUnit == "MB"){
      return readableBytesAsMB(val).replace(" MB", "");
    }
    else if(customUnit == "GB"){
      return readableBytesAsGB(val).replace(" GB", "");
    }
  }

export const generateCustomUsageCSV = (chart: Highcharts.Chart, dataUnit = "GB") => {
    const series = chart.series.filter(s => s.visible);
    if (!series.length) return "";
    const gbHeaders = series.map(s => `${s.name} (${dataUnit})`);
    const bytesHeaders = series.map(s => `${s.name} (${customUnit})`);
    const header = ["Time", ...gbHeaders, ...bytesHeaders];
    const xValues = series[0].data.map(point => point.x);

    const rows = xValues.map((x, i) => {
        const time = Highcharts.dateFormat("%Y-%m-%d %H:%M:%S", x);

        const gbValues = series.map(s => {
          const point = s.data[i];
          return point?.y ?? 0;
        });

        const bytesValues = series.map(s => {
          const point: any = s.data[i];
          return point?.bytes ? toCustomUnit(point?.bytes) :  0;
        });
        return [time, ...gbValues, ...bytesValues];
    });

    const csv = [header, ...rows]
      .map(row => row.join(","))
      .join("\n");
    return csv;
};

export const readablePeriod = (value: number, unit: string) => {
  let dur = unit === 'Y' || unit === 'M' || unit === 'W' || unit === 'D' ? moment.duration(`P${value}${unit}`) : moment.duration(`PT${value}${unit}`.toUpperCase());
  let humanized = dur.humanize()
  if (humanized === "a minute") {
    return "1 minute"
  }else if (humanized === "an hour") {
    return "1 hour"
  } else if (humanized === "a day") {
    return "1 day"
  } else if (humanized === "a month") {
    return "1 month"
  } else if (humanized === "a year") {
    return "1 year"
  } else {
    return humanized
  };
  // return duration.humanize();
}

export const periodToMinutes = (period: string): number => {
  let periodValue = parseInt(period.substring(0, period.length - 1));
  let periodUnit = period.substring(period.length - 1);
  switch (periodUnit) {
    case "D":
      return periodValue * 24 * 60;
    case "W":
      return periodValue * 7 * 24 * 60;
    case "M":
      return periodValue * 30 * 24 * 60;
    default:
      return periodValue;
  }
}

export const extractEmails = (text: string) => {
  return Array.from(new Set<string>(text.match(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/gi) || []));
}

export const calibrateData = (oldUnit: string, newUnit: string, value: string) => {
  switch (newUnit) {
    case 'MB':
      if (oldUnit === 'GB') {
        return `${Number(value) * 1024}`;
      } else if (oldUnit === 'TB') {
        return `${Number(value) * 1024 * 1024}`;
      }
      break;
    case 'GB':
      if (oldUnit === 'MB') {
        return `${Number(value) / 1024}`;
      } else if (oldUnit === 'TB') {
        return `${Number(value) * 1024}`;
      }
      break;
    case 'TB':
      if (oldUnit === 'MB') {
        return `${Number(value) / 1024 / 1024}`;
      } else if (oldUnit === 'GB') {
        return `${Number(value) / 1024}`;
      }
      break;
    default:
      return value;
  }
  return value
}

export const readableBits = (bytes: any) => {
  let _bytes = bytes;
  if (_bytes <= 0) {
    return "-";
  }
  let i: number = Math.floor(Math.log(_bytes) / Math.log(1024));
  let sizes: string[] = ['bps', 'Kbps', 'Mbps', 'Gbps', 'Tbps'];
  return (_bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
}

export const getEncodedURI = (data: any) => {
  if (!data) {
    data = {}
  }
  return Object.keys(data).map(function (k) {
    return encodeURIComponent(k) + '=' + encodeURIComponent(data[k])
  }).join('&');
}

export const getDecodeURI = (line: any) => {
  if (!line) {
    line = ""
  }
  if (line.startsWith("?")) {
    line = line.substring(1);
  }
  if ('' === line.trim()) {
    return {};
  }
  let _line = decodeURIComponent(line);
  let ouName = new URLSearchParams(window.location.search).get('ouName');
  let k4Ids = new URLSearchParams(window.location.search).get('k4Ids');
  let search =  new URLSearchParams(window.location.search).get('search');
  let key = "";
  let value = "";
  let keyValue = ""
  let newLineObj = {};
  if(ouName && ouName?.includes('&') || k4Ids && k4Ids?.includes('&') || search && search?.includes('&')) {
      let newLine = _line.split('&').forEach((item:any) => {
        if(item.includes('ouName') || !item.includes('=') || item.includes('k4Ids') ||  item.includes('search')) {
            // ignore
        } else {
           keyValue = item.split('=');
           if(keyValue) {
            key = keyValue[0];
            value = keyValue[1];
            newLineObj[key] = value;
           }
        }
      })
      if(ouName) {
        newLineObj['ouName'] = ouName;
      }
      if(k4Ids) {
        newLineObj['k4Ids'] = k4Ids;
      }
      if(search) {
        newLineObj['search'] = search;
      }
    return newLineObj;
  } else {
    return Object.fromEntries(_line.split('&').map(item => item.split('=')));
  }
}

export const strToK4List = (line: any) => {
  if (!line || '' === line.trim()) {
    return {};
  }
  return line.split(",").map((k4id) => {
    let _s = k4id.split(":");
    if (2 == _s.length) {
      return ({ 'id': _s[0], 'vessel-name': _s[1] })
    } else {
      return ({ 'id': '', 'vessel-name': '' })
    }
  });
}

export const strToK4HubList = (line: any) => {
  if (!line || '' === line.trim()) {
    return {};
  }
  return line.split(",").map((k4id) => {
    let _s = k4id.split(":");
    if (2 == _s.length) {
      return ({ 'k4Id': _s[0], 'site_name': _s[1] })
    } else {
      return ({ 'k4Id': '', 'site_name': '' })
    }
  });
}

export const strToK4IdList = (line: any) => {
  if (!line || '' === line.trim()) {
    return {};
  }
  return line.split(",K4-").map((k4id, i) => {
    let _s:any = [];
    if(i == 0) {
      _s = k4id.split(":");
    } else {
      let newk4id = `K4-${k4id}`;
      _s = newk4id.split(":");
    }
    return (2 == _s.length) ? _s[0] : '';
  });
}

export const strToList = (line: any) => {
  if (!line || '' === line.trim()) {
    return [];
  }
  return line.split(",");
}

export const siteObjListToK4IdList = (sites: any[]) => {
  let k4Ids: string[] = []
  for (let site of sites) {
    if (site && site?.site_id) {
      k4Ids.push(site?.site_id)
    }
  }
  return k4Ids
}

export const k4IdsToUrlString = (k4Ids: any, locations: any) => {
  let urlString = k4Ids?.map((k4Id: any) => {
      let location = locations?.find((location: any) => location?.id === k4Id)
      return location ? `${location?.id}:${location?.name}` : null
    }
  )
  .filter(Boolean)
  .join(",")
  
  return urlString
}

export const handleRemoveT0Sites = (currentData: any, t0AndT91Sites: any) => {
  let t0Sites = siteObjListToK4IdList(t0AndT91Sites)
  let nonT0Sites: any = []
  for (let location of currentData) {
      if (!t0Sites?.includes(location?.id)) {
          nonT0Sites.push(location)
      }
  }
  return nonT0Sites
}

export const fnRound = (n, d) => {
  return Math.round(n * Math.pow(10, d)) / Math.pow(10, d);
};

export const fnComma = (x) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const queryParamK4Ids = "queryParamK4Ids";
export const redirectToTopolgyTabs = (location,pathName,k4Id,siteName,otherQueryParms,saveRequired,keepOnlyOuNameouIdK4IdsInParams, tailId=null) =>{
  let params = getDecodeURI(location?.search);
  if(saveRequired){
    saveQueryParamK4Ids(params);
  }
  params.k4Ids = k4Id + ":" + siteName;
  params.tailId = tailId;
  if(keepOnlyOuNameouIdK4IdsInParams){
    let p = {};
    p["k4Ids"] = params.k4Ids
    if(params.ouName){
      p["ouName"] = params.ouName
    }
    if(params.ouId){
      p["ouId"] = params.ouId
    }
    params = p
  }

  if(!_.isEmpty(otherQueryParms)){
    params = {...params,...otherQueryParms};
  }
  if(pathName == '/reports/activity') {
    params = {...params, topAppClick: true}
  }

  return { pathname: pathName, search: `?${getEncodedURI(params)}` }
}

export const saveQueryParamK4Ids = (params)=> {
  if (params?.k4Ids && localStorage.getItem(queryParamK4Ids) !== params.k4Ids) {
    localStorage.setItem(queryParamK4Ids, params.k4Ids);
  }else if(!(params?.k4Ids)){
    localStorage.removeItem(queryParamK4Ids)
  }
}

export const removeQueryParamK4Ids = () => {
  if(localStorage.getItem(queryParamK4Ids)){
    localStorage.removeItem(queryParamK4Ids)
  }
}

export function populateForParent(data, parentid, org) {
  let _newitem: any = {
    name: data.name,
    id: data.id,
    _childern: []
  };
  if (data && data.parent_of) {
    for (let child of data.parent_of) {
      let newitem: any = {
        name: child.name,
        id: child.id
      }
      _newitem._childern.push(newitem)
      if (child.parent_of) {
        newitem["_childern"] = [];
        for(let nextChild of child.parent_of){
        populateForParent(nextChild, newitem.id, newitem._childern);
        }
      }
    }
  }
  org.push(_newitem)
  return org
}

export const getChildren = (dpIds, dps) => {
  dps.forEach(dp => {
    let id = dp?.id
    dpIds.push(id)
    if (dp.hasOwnProperty('_childern') && dp['_childern']?.length > 0) {
      getChildren(dpIds, dp['_childern'])
    }
  })
}

export const getParentAndSubDpIds = (dpId, dpList) => {
  const _dpIds: any = []
  const parentDpId = dpId;
  const dpIds = dpList
  if (dpIds.hasOwnProperty(parentDpId)) {
    _dpIds.push(parentDpId)
    getChildren(_dpIds, dpIds[parentDpId])
  }
  return _dpIds
}

export function getParentDp(dp_list,dp_name,){
  let parent_dp:any=null;
  for(let dp of dp_list){
    if(dp.name===dp_name){parent_dp=populateForParent(dp,null,[]);
      break;  
    } else{
      if(dp?.parent_of?.length){
        let parent_org=getParentDp(dp.parent_of,dp_name);
        if(parent_org && parent_org!==undefined) return parent_org;
      }
    }
  }
  return parent_dp;
}

export const getUserOu = () => {
  let _userOu = localStorage.getItem(USER_OU);
  let userOu = {}
  if(_userOu){
    try {
      userOu = JSON.parse(_userOu)
    } catch (error) {
      console.log(error)
    }
  }
  return userOu
}

export const getInvitedOuList = (dpList) => {
  let invitedOus: any[] = []
  let _userOu = localStorage.getItem(USER_OU);
  if (_userOu) {
    try {
      let userOu = JSON.parse(_userOu)
      if (!_.isEmpty(userOu) && !_.isEmpty(dpList) && dpList?.dps && Array.isArray(dpList.dps) && dpList.dps.length > 0) {
        for (let i = 0; i < dpList.dps.length; i++) {
          let dp = dpList.dps[i]
          if (userOu?.id && !_.isEmpty(dp) && dp?.id && userOu.id !== dp.id) {
            invitedOus.push({
              "id":dp?.id,
              "name":dp?.name
            })
            getChildOus(dp, invitedOus)
          }
        }
      }
    } catch (error) {
      console.log(error)
    }
  }
  return invitedOus
}

export const getloggedInUserOuandSubOusList = (dpList) => {
  let userOus: any[] = []
  let _userOu = localStorage.getItem(USER_OU);
  if (_userOu) {
    try {
      let userOu = JSON.parse(_userOu)
      if (!_.isEmpty(userOu) && !_.isEmpty(dpList) && dpList?.dps && Array.isArray(dpList.dps) && dpList.dps.length > 0) {
        for (let i = 0; i < dpList.dps.length; i++) {
          let dp = dpList.dps[i]
          if (userOu?.id && !_.isEmpty(dp) && dp?.id && userOu.id == dp.id) {
            userOus.push({
              "id": dp?.id,
              "name": dp?.name
            })
            getChildOus(dp, userOus)
          }
        }
      }
    } catch (error) {
      console.log(error)
    }
  }
  return userOus
}

const getChildOus = (dp, invitedOus) => {
  if (dp?.parent_of && Array.isArray(dp.parent_of) && dp.parent_of.length > 0) {
    let childDps = dp.parent_of;
    for (let i = 0; i < childDps.length; i++) {
      invitedOus.push({
        "id":childDps[i]?.id,
        "name":childDps[i]?.name
      })
      getChildOus(childDps[i], invitedOus)
    }
  }
}

export const checkSelectedOuIsInvitedOu = (selectedOu, invitedOus) => {
  let isSelectedOuIsInvitedOu = false;
  let _userOu = localStorage.getItem(USER_OU);
  if (_userOu && invitedOus.length>0) {
    try {
      let userOu = JSON.parse(_userOu)
      if(!_.isEqual(userOu,selectedOu)){
        for(let i=0; i<invitedOus.length;i++){
          if(_.isEqual(selectedOu,invitedOus[i])){
            isSelectedOuIsInvitedOu = true
            break
          }
        }
      }
    } catch (error) {
      console.log(error)
    }
  }
  return isSelectedOuIsInvitedOu;
}

export const getOu = (organisations, selectedOu, dpList) => {
  let ou = selectedOu;
  if (organisations.length > 1) {
    let invitedOus = getInvitedOuList(dpList)
    let isSelectedOuIsInvitedOu = checkSelectedOuIsInvitedOu(selectedOu, invitedOus)
    if (isSelectedOuIsInvitedOu) {
      let userOu = getUserOu()
      ou = userOu
    }
  }
  return ou
}

export const getOuforReports = (organisations, selectedOu, dpList) => {
  let ou = selectedOu;
  if (organisations.length > 1) {
    let invitedOus = getInvitedOuList(dpList)
    //let isSelectedOuIsInvitedOu = checkSelectedOuIsInvitedOu(selectedOu, invitedOus)
    // if (isSelectedOuIsInvitedOu) {
    //   let userOu = getUserOu()
    //   ou = userOu
    // }
  }
  return ou
}
export const generatePDFfile = (header, tableHeaders, tableData, fileName) => {
  const doc = new jsPDF('l', 'pt', 'a4');
  doc.text(header, 10, 25)
  autoTable(doc, {
    head: [tableHeaders],
    body: tableData,
    theme: "striped",
    startY: 50,
    margin: 10,
    headStyles: {
      fillColor: "#264C86"
    }
  });
  doc.save(fileName);
}

export const convertDateTimeIntoTimezone = (stringDate, timezone, requiredFormat) => {
  let formattedDate = ""
    try {
      timezone = getTimezoneCity(timezone)
      if (!_.isEmpty(stringDate) && !stringDate.startsWith("0001-01-01")) {
        let date = moment.tz(stringDate, 'UTC').tz(timezone).format(requiredFormat)
        if (date.toLocaleLowerCase() != "invalid date") {
            formattedDate = date //.replace(",", "")
        }
      }
    }
    catch (err) {
      console.log(err)
    }
  return formattedDate
}

export const getTimezoneCity = (timezone: string) => {
  // ex: Asia/Colombo
  let city = ""
  if (!_.isEmpty(timezone)) {
    city = timezone.split(" - ")[0]
  }
  return city
}

export const escapeRegExp = (string) => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export const getMinutes = (start, end) => {
  return Math.ceil(((new Date(end)).getTime() - (new Date(start)).getTime()) / 60e3);
}

export const getDateForChart = (data) => {
  if(data?.length > 1) {
    for(let i = 0; i < data?.length; i++) {
      if(data[i]?.data?.length > 1) {
        return false;
      }
    }
  }
  if(data?.length == 1 && data[0]?.data?.length == 1) {
    return true;
  } else if(data?.length > 1 && data[0]?.data?.[0]?.x == data[1]?.data?.[0]?.x) {
    return true;
  } else {
    return false;
  }
}

export const getSingleRecordChartLable = (data, timezone) => {
  return moment(new Date(data[0]?.data?.[0]?.x)).tz(timezone).format('DD-MMM, hh:mm');
}

export const getIntervalCheck = (minutes) => {
  if (minutes > 10080) {
    return true;
  } 
  return false;
}

export const getUserGuide = (pageName: string, domain) => {
  if(domain) {
    window.open(`${domain}/cld/${pageName}`);
  } else {
    window.open(`https://kb.kognitive.net/kb/cld/${pageName}`);
  }
}

const getLastThreeMonths = () => {
  const months:any = [];
  const currentDate = new Date();
  for (let i = 0; i < 3; i++) {
    // Subtract i months from the current date
    const date = new Date(currentDate.getFullYear(), currentDate.getMonth() - i, 1);
    const formattedDate = date.toISOString().slice(0, 7); // Format as YYYY-MM
    months.push(formattedDate);
  }
  return months;
}

export const getStartEndTime = (location) => {
  let start: any = {};
  let end: any = {};
  let params: any = getDecodeURI(location?.search);
  const selectedInterval = params.hasOwnProperty('interval') ? params.interval : '1h';
  let interval:any = {
    duration: 60,
    timeVal: 'minutes'
  }
  for (let i = 0; i < NEWINTERVALS.length; i++) {
    if(selectedInterval == NEWINTERVALS[i].value) {
      interval.duration = NEWINTERVALS[i].duration;
      interval.timeVal = NEWINTERVALS[i].timeVal;
    }
  }
  if (params.hasOwnProperty('interval') && (params.interval == 'customDates' || params.interval == 'MTD')) {
    start = moment(new Date(parseInt(params.startDate)));
    end = moment(new Date(parseInt(params.endDate)));
  } else if(params.hasOwnProperty('interval') && getLastThreeMonths().includes(params.interval)) {
    start = moment(new Date(parseInt(params.startDate)));
    end = moment(new Date(parseInt(params.endDate)));
  } else {
    start = moment(Date.now()).subtract(Number(interval.duration), interval.timeVal).utc();
    end = moment(Date.now()).utc();
  }
  return { startDate: start, endDate: end }
}

export const updateTimePeriod = (dispatch, location) => {
  const { startDate, endDate } = getStartEndTime(location);

  dispatch({ type: UPDATE_NEW_SUMMARY_START_DATE, payload: startDate.utc() })
  dispatch({ type: UPDATE_NEW_SUMMARY_END_DATE, payload: endDate.utc() })
  return { startDate: startDate.valueOf(), endDate: endDate.valueOf() };
}

export const getApproxStartEndDate = (startDate, endDate, timezoneCity) => {
  const approxObj = approximateDateRange(startDate, endDate);
  const approxStart = moment.tz(approxObj.startDate, timezoneCity);
  const approxEnd = moment.tz(approxObj.endDate, timezoneCity);
  return { approxStart, approxEnd };
}

export const formatSize = (value) => {
  if (value >= 1000) {
      return (value / 1000).toFixed(2) + ' TB';
  }
  return value.toFixed(2) + ' GB';
};

export const formatDataSizeAsTB = (value) => {
  return (value / 1000).toFixed(2) + ' TB';
};

// Check both T0 and T101
export const checkT0Tier = (licenseTier: string): boolean => {
    if (licenseTier && (licenseTier?.includes(T0_TIER) || licenseTier === T101_TIER)) {
        return true
    }
    return false
}

// Check wither the tier is T0,T101 or not
export const handleValidateTier = (row: any) => {
  if (row?.["licenseTier"]?.includes(T0_TIER) || [T91_TIER]?.includes(row?.["licenseTier"])) {
      return false
  }
  return true
}

 const menuItems = [
        {
            key: "dashboard",
            label: "Sites",
            icon: SidebarNavCategoryIcon,
            value: SIDE_MENU_ITEM_DASHBOARD,
            path: "/fleet-dashboard/sites",
        },
        {
            key: "trends",
            label: "Trends",
            icon: StandardIcon,
            value: SIDE_MENU_ITEM_TRENDS,
            path: "/fleet-dashboard/newsummary/sites",
        },
        {
            key: 'threats',
            label: 'Threats',
            icon: SideNavInventory,
            value: SIDE_MENU_ITEM_CYBER,
            path: `/${CYBER}`,
        },
        {
            key: 'Hub',
            label: 'Hub',
            icon: SideNavInventory,
            value: SIDE_MENU_ITEM_HUB,
            path: `/${HUB}`,
        },
        {
            key: "map",
            label: "Map",
            icon: SidebarNavMapIcon,
            value: SIDE_MENU_ITEM_MAP,
            path: "/vessel-map",
        },
        {
            key: "reports",
            label: "Reports",
            icon: SidebarNavNotesIcon,
            value: SIDE_MENU_ITEM_SIM_REPORTS,
            path: "/reports/generatedReports",
        },
       {
            key: "accountManagement",
            label: "Account Management",
            icon: SidebarNavUserIcon,
            value: SIDE_MENU_ITEM_ACCOUNT_MANAGEMENT,
            path: "/account-management/accounts",
        },
        {
            key: "alerts",
            label: "Alerts",
            icon: SidebarNavNotificationIcon,
            value: SIDE_MENU_ITEM_ALERTS,
            path: "/alerts/alerts",
        },
        {
                key: "auditLogs",
                label: "Audit Logs *",
                icon: SidebarNavDescription,
                value: SIDE_MENU_ITEM_AUDIT_LOGS,
                path: "/audit-logs",
            },  
        ...(localStorage.getItem("isBetaUser") === "true") ? [
          {
            key: "tickets",
            label: "Tickets *",
            icon: SidebarNavTicketsIcon,
            value: SIDE_MENU_ITEM_TICKETS,
            path: "/tickets",
          }] : [],
        {
            key: "softwareListing",
            label: "S/W Configuration",
            icon: SideNavSwConfigIcon,
            value: SIDE_MENU_ITEM_SOFTWARE_LISTING,
            path: "/softwareList",
        },
        {
            key: "inventory",
            label: "Inventory",
            icon: SideNavInventory,
            value: SIDE_MENU_ITEM_INVENTORY,
            path: "/inventory",
        },
        {
            key: `${window?.location?.host.includes("pulsar") ? "Control" : "Kontrol"}`,
            label: `${window?.location?.host.includes("pulsar") ? "Control" : "Kontrol"}`,
            icon: SideNavQuotaControl,
            value: SIDE_MENU_ITEM_GEO_MANAGEMENT,
            path: `/${KONTROL_MANAGEMENT}/quota_configuration`,
        },
        {
                key: "contentFilter",
                label: "Content Filter *",
                icon: SideNavContentFilter1,
                value: SIDE_MENU_ITEM_CONTENT_FILTER,
                path: "/content-filter/configuration",
            },
            {
                key: "starlink",
                label: "Starlink",
                icon: SideNavStarlink,
                value: SIDE_MENU_ITEM_STARLINK,
                path: "/starlink/starlinkMap",
            },
            {
                key: "captive",
                label: "Captive portal",
                icon: SideNavCaptive,
                value: SIDE_MENU_ITEM_CAPTIVE,
                path: "/captive",
            },  
            {
                key: 'Topology',
                label: 'Topology *',
                icon: TopologyIc,
                value: SIDE_MENU_ITEM_TOPOLOGY,
                path: `/${SIDE_MENU_ITEM_TOPOLOGY}`
            },
            ...(localStorage.getItem("isBetaUser") === "true")
              ? [
                {
                  key: "analytics",
                  label: "Analytics *",
                  icon: SideNavAnalytics,
                  value: SIDE_MENU_ITEM_ANALYTICS,
                  path: "/analytics-dashboard/trends",
                },
              ]
              : [],
            {
                key: "dataNavigator",
                label: "Torm Dashboard",
                icon: SideNavDataNavigator,
                value: SIDE_MENU_ITEM_DATA_NAVIGATOR,
                path: "/data-navigator/overview",
            },
       ];

export const getSideNavMenusURL=(dispatch, dpId)=>{
let new_menu_items=[...menuItems];
let dashboardURLPath = "/fleet-dashboard/sites";
let url_params=`k4Ids=K4-0620%3AMY-FirstVessel&`;

const service = JSON.parse(localStorage.getItem('permissions') || '[]');
const loginObj = JSON.parse(localStorage.getItem('loggedInUser') || '[]')
const isReadOnlyUser=loginObj?.data?.user?.sportReadOnlyUser;
const onlyStarlinkUser = getDataFromLocalStorageParsed("loggedInUser")?.data?.user?.starlinkOnlyUser;
const onlyCaptiveUser = getDataFromLocalStorageParsed("loggedInUser")?.data?.user?.canOnlyUser;
 const isStarlinkAdmin = getDataFromLocalStorageParsed("loggedInUser")?.data?.is_sl_admin


let isStarLinkEnabled=false;
const is_site_admin=loginObj?.data?.is_site_admin;
const is_sl_admin=loginObj?.data?.is_sl_admin;
let isBetaUser=localStorage.getItem("isBetaUser") === "false"?false:true;
const schedule_report_path='/reports/reports';

if(is_site_admin && isBetaUser) dispatch({type:SITE_ADMIN_ACCESS,payload:true})
if(is_sl_admin && isBetaUser)dispatch({type:SL_ADMIN_ACCESS,payload:true})

let itemList:string[]=[],
 items_to_hide:string[]=[],
 is_client=false,
 other_access=false;

if(service) {
  service?.map((list)=>{
      if(list.service == 'starlink'){
        isStarLinkEnabled=true;
        other_access=true;
      }
      if(list.service==='client' && list?.servicefunctions?.length && list.servicefunctions.some((sf)=>sf.function==='ReportRO') && !list.servicefunctions.some((sf)=>sf.function==='ReportRW'))is_client=true;
      else if(list.service!=='iam' && list.service!=='serviceportal')other_access=true; 
    })
}
  if(is_client){
    if(!other_access){
      itemList.push('reports');
     // dashboardURLPath="/reports/generatedReports";
      url_params=`sideNav=true&`;
    }    
      dispatch({type:LIMITED_REPORT_ACCESS,payload:true})
    }

  if(onlyCaptiveUser)itemList.push('captive');
  if(onlyStarlinkUser)itemList.push('starlink');
  if(isStarlinkAdmin && onlyStarlinkUser){
    if(isBetaUser)itemList.push('reports');
    itemList.push('accountManagement');
  }


  if(localStorage.getItem("isAccountsEnabled") === "false" || isReadOnlyUser)items_to_hide.push('accountManagement');
  if(!isBetaUser || isReadOnlyUser)items_to_hide.push('auditLogs')
  if(isReadOnlyUser) items_to_hide.push(...['tickets','softwareListing']);
  if(localStorage.getItem("ccfEnabled") === "false")items_to_hide.push('contentFilter');
  if(localStorage.getItem(CAPTIVE_ACCESS_ENABLED) === "false")items_to_hide.push('captive');
   if(!isBetaUser)items_to_hide.push('Topology');
  let isSiteAdmin = getDataFromLocalStorageParsed("loggedInUser")?.data?.is_site_admin
  if (dpId === "DP-0121" && isSiteAdmin) {
  const index = items_to_hide.indexOf("Topology");
  if (index !== -1) {
    items_to_hide.splice(index, 1);
  }
  }
  if(!onlyStarlinkUser && !isStarLinkEnabled)items_to_hide.push('starlink');
  if(dpId !== "DP-0001")items_to_hide.push('dataNavigator');

  if(itemList?.length){
    let menu_items:any[]=[]
    itemList.map((list)=>{
      let item=menuItems.find((item)=>item.key===list)
      if(item!==undefined)menu_items.push(item);
      new_menu_items=[...menu_items]
    })
    dashboardURLPath=is_client && !other_access ? schedule_report_path : new_menu_items[0].path
  }
  if(items_to_hide?.length){
    items_to_hide.map((item)=>{
      let findIdx=new_menu_items.findIndex((menu)=>menu.key===item)
      if(findIdx>-1)new_menu_items.splice(findIdx,1)
    })
  }
if(new_menu_items?.length){
  let reportIndex=new_menu_items.findIndex((itm)=>itm.key==='reports');
  if(reportIndex>-1 && (is_client || (isStarlinkAdmin && onlyStarlinkUser))){
    let reportObj=new_menu_items[reportIndex];
    new_menu_items[reportIndex]={...reportObj,path:schedule_report_path}
  }
}
return {new_menu_items:new_menu_items,dashboardURLPath:dashboardURLPath,url_params:url_params};
}

export const handleDownloadURL=(resp,fileName)=>{
  const url = window.URL.createObjectURL(new Blob([resp.data], {type: resp.headers['content-type'],}));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
}

export const getChildrenDpList = (dp_list: any) => {
  let child_dp_list: string[] = [];
  if (dp_list?.parent_of?.length) {
    dp_list.parent_of.forEach(async (dp) => {
      child_dp_list.push(dp.id);
      if (dp?.parent_of?.length) {
        child_dp_list = child_dp_list.concat(getChildrenDpList(dp));
      }
    });
  }
  return child_dp_list;
};

export const patterns = {
  kit: /^KIT[0-9A-Z]{6,}$/,
  starlinkId: /^[0-9a-f]{8}-[0-9a-f]{8}-[0-9a-f]{8}$/i,
  dish: /^[A-Z0-9]{11,20}$/
};

export function formatStarlinkId(input: string) {
  const cleaned = input.replace(/[^0-9a-f]/gi, "");

  if (cleaned.length < 8) {
    return cleaned;
  }

  const parts: string[] = [];
  if (cleaned.length >= 8) parts.push(cleaned.substring(0, 8));
  if (cleaned.length >= 16) parts.push(cleaned.substring(8, 16));
  if (cleaned.length >= 24) parts.push(cleaned.substring(16, 24));
  if (cleaned.length > 24) parts.push(cleaned.substring(24, 32));

  return parts.join("-");
}

export function validateKITInput(id: string) {
  const trimmed = id.trim();
  if (!trimmed) return { id, type: "EMPTY", valid: false };
  if (!/^[A-Z0-9-]+$/i.test(trimmed)) { return { id, type: "CHARACTER (A–Z, a–z, 0–9 and '-' allowed)", valid: false }; }
  if (patterns.kit.test(trimmed)) { return { id, type: "KIT_SERIAL_NUMBER", valid: true }; }
  if (patterns.starlinkId.test(trimmed)) { return { id, type: "USER_TERMINAL_ID", valid: true }; }
  if (patterns.dish.test(trimmed)) { return { id, type: "DISH_SERIAL_NUMBER", valid: true }; }
  return { id, type: "UNKNOWN", valid: false };
}

export const validateIp = (ip: string, required: boolean = true): string => {
  const ipRegex = /^(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)){3}$/;

  if (!required && !ip) {
    return "";
  }

  if (!ip) return "IP Address is required";
  if (!ipRegex.test(ip)) return "Invalid IP Address format";

  return "";
};

export const validateMac = (mac: string): string => {
  const macRegex = /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/;

  if (!mac) return "MAC Address is required";
  if (!macRegex.test(mac)) return "Invalid MAC Address format";

  return "";
};

export const validatePort = (port: string, required: boolean = true): string => {
  if (!required && !port) {
    return "";
  }

  if (!port) {
    return "Port is required";
  }

  const trimmed = port.trim();

  if (trimmed.endsWith(",")) {
    return "Please provide another port or range after comma.";
  }

  const entries = trimmed.split(",").map((p) => p.trim()).filter(Boolean);

  for (const entry of entries) {
    if (entry.includes("-")) {
      const [start, end] = entry.split("-").map((p) => Number(p));

      if (
        isNaN(start) ||
        isNaN(end) ||
        !Number.isInteger(start) ||
        !Number.isInteger(end)
      ) {
        return `Invalid port range "${entry}". Use valid numbers like 1000-2000.`;
      }

      if (start < 1 || end > 65535 || start >= end) {
        return `Invalid port range "${entry}". Ports must be between 1-65535 and start < end.`;
      }

      continue;
    }

    const portNum = Number(entry);

    if (isNaN(portNum) || !Number.isInteger(portNum)) {
      return `Invalid port "${entry}". Port must be a number.`;
    }

    if (portNum < 1 || portNum > 65535) {
      return `Invalid port "${entry}". Port must be between 1 and 65535.`;
    }
  }

  return "";
};

export const validateIpOrSubnet = (input: string, required: boolean = true): string => {
  if (!required && !input) {
    return "";
  }

  if (!input) {
    return "Address is required.";
  }

  const ipv4Regex =
    /^(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)){3}$/;

  const trimmedInput = input.trim();
  if (trimmedInput.endsWith(",")) {
    return "Please provide another IP or subnet after comma.";
  }

  const entries = input.split(",").map((e) => e.trim()).filter(Boolean);

  for (const entry of entries) {
    if (ipv4Regex.test(entry)) continue;

    if (entry.includes("/")) {
      const [ip, cidr] = entry.split("/");
      if (!ipv4Regex.test(ip)) return `Invalid IP format in "${entry}".`;
      if (cidr === undefined || cidr.trim() === "") return `Subnet is required after '/' in "${entry}".`;
      const cidrNum = Number(cidr);
      if (isNaN(cidrNum) || !Number.isInteger(cidrNum))
        return `Subnet must be a number in "${entry}".`;
      if (cidrNum < 0 || cidrNum > 32)
        return `Subnet must be between 0 and 32 in "${entry}".`;
      continue;
    }

    return `Invalid format in "${entry}". Use IP or IP/CIDR (e.g. 192.168.1.1 or 192.168.1.1/24).`;
  }

  return "";
};

export const validateDomain = (domain: string): string | null => {
  const domainRegex = /^(?!:\/\/)([a-zA-Z0-9-_]+\.)+[a-zA-Z]{2,}$/;
  if (!domain) return "Domain is required";
  if (!domainRegex.test(domain)) return "Invalid domain format";
  return '';
}

export const ipv4Regex = /^(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)){3}$/;

export const netmaskToCIDR = (netmask: string): number => {
  return netmask
    .split('.')
    .map(Number)
    .map(octet => octet.toString(2))
    .join('')
    .split('1').length - 1;
};

export const cidrToNetmask = (cidr: number): string => {
  const mask = ~(2 ** (32 - cidr) - 1);
  return [
    (mask >>> 24) & 255,
    (mask >>> 16) & 255,
    (mask >>> 8) & 255,
    mask & 255
  ].join('.');
};

const STARLINK_ADMIN_SF = "starlink-admin";
    const STARLINK_FULL_SF = "starlink-full";


export const STARLINK_FEATURES = {
  user: {
    service: SERVICE_FUNCTION_TO_FEATURE["starlink-user"].service,
    function: SERVICE_FUNCTION_TO_FEATURE["starlink-user"].function,
  },
  admin: {
    service: SERVICE_FUNCTION_TO_FEATURE[STARLINK_ADMIN_SF].service,
    function: SERVICE_FUNCTION_TO_FEATURE[STARLINK_ADMIN_SF].function,
  },
  full: {
    service: SERVICE_FUNCTION_TO_FEATURE[STARLINK_FULL_SF].service,
    function: SERVICE_FUNCTION_TO_FEATURE[STARLINK_FULL_SF].function,
  },
};


export const isAuthorizedFor = (role) => {
  const { service, function: fn } = STARLINK_FEATURES[role];
  return checkLoggedInUserAuthorizedToViewPage(service, fn);
};


export const useAuthorization = () => {
  const isAdmin = isAuthorizedFor("admin");
  const isFull = isAuthorizedFor("full");
  const isUser = isAuthorizedFor("user");


  return {
    isAdmin,
    isFull,
    isUser,
    canViewAdmin: isAdmin || isFull,
    canViewUser: isUser || isFull,
  };
};


// Period options
export const PERIOD_OPTIONS = {
  default: ['1h', '6h', '12h', '1d', '7d', '30d', 'MTD', 'customDates'],
  plans: ['1h', '6h', '12h', '1d', '7d', '30d', 'MTD', 'plans', 'customDates'],
  usage: ['1d', '7d', '30d', 'MTD', ...getLastThreeMonth(), 'customDates'],
  dashboard: ['1d', '7d', '30d', 'MTD', 'customDates'],
};


export const getSource = (tableParams) => {
    const endDate = moment(tableParams.endDate, 'YYYY-MM-DD HH:mm:ss');
    const startDate = moment(tableParams.startDate, 'YYYY-MM-DD HH:mm:ss');


    const hoursDifference = moment.duration(endDate.diff(startDate)).asHours();


    if (hoursDifference < 6) {
      return '_agg_1h';
    } else if (hoursDifference >= 6 && hoursDifference < 24) {
      return '_agg_6h';
    } else if (hoursDifference >= 24 && hoursDifference < 168) {
      return '_agg_1day';
    } else if (hoursDifference >= 168) {
      return '_agg_1week';
    } else {
      return ''
    }
  }


  export const getUsageSource = (tableParams) => {
      const endDate = moment(tableParams.endDate, 'YYYY-MM-DD HH:mm:ss');
      const startDate = moment(tableParams.startDate, 'YYYY-MM-DD HH:mm:ss');


      const hoursDifference = moment.duration(endDate.diff(startDate)).asHours();
      if (hoursDifference <= 24) {
        return 'aggregation_table';
      } else if (hoursDifference > 24) {
        return 'direct_source';
      } else {
        return ''
      }
    }

     export const BINS = [
    { min: 1, label: "1m", value: "1 minute" },
    { min: 3, label: "3m", value: "3 minute" },
    { min: 5, label: "5m", value: "5 minute" },
    { min: 10, label: "10m", value: "10 minute" },
    { min: 15, label: "15m", value: "15 minute" },
    { min: 20, label: "20m", value: "20 minute" },
    { min: 60, label: "1h", value: "1 hour" },
    { min: 360, label: "6h", value: "6 hour" },
    { min: 720, label: "12h", value: "12 hour" },
    { min: 1440, label: "1d", value: "1 day" },
    { min: 10080, label: "7d", value: "7 day" },
  ];

export const getAllowedBins = (totalMinutes) => {
  const ONE_HOUR = 60;
  const ONE_DAY = 1440;
  const SEVEN_DAYS = 10080;

  if (totalMinutes <= ONE_HOUR) {
    return ["1 minute","3 minute","5 minute","10 minute","15 minute","20 minute"];
  }

  if (totalMinutes > ONE_HOUR && totalMinutes <= ONE_DAY) {
    return ["1 minute","3 minute","5 minute","10 minute","15 minute","20 minute","1 hour"];
  }

  if (totalMinutes > ONE_DAY && totalMinutes <= SEVEN_DAYS) {
    return ["5 minute","10 minute","15 minute","20 minute","1 hour","6 hour","12 hour","1 day"];
  }

  if (totalMinutes > SEVEN_DAYS) {
      return ["1 hour","6 hour","12 hour","1 day", "7 Day"];
  }

  return BINS.filter(b => b.min <= totalMinutes).map(b => b.value);
};

export const getAnalyticsSource = (totalMinutes) => {
  const allowed =  ["1 minute","3 minute","5 minute","10 minute","15 minute","20 minute","1 hour"];

  return allowed.includes(totalMinutes) ? "" : "_agg_1h";
};

    /**
   * Converts uptime from total seconds into a human-readable format (e.g., "5h 32m 10s").
   * If uptimeSeconds is null/undefined/0, returns "--".
   *
   * @param {number} uptimeSeconds - Total uptime in seconds.
   * @returns {string} Formatted uptime string.
   */
    export const convertSecondsToUptime = (uptimeSeconds) => {
      if (!uptimeSeconds && uptimeSeconds !== 0) return "";

      const totalSeconds = Math.floor(uptimeSeconds);

      const secondsInMinute = 60;
      const secondsInHour = 3600;
      const secondsInDay = 86400;
      const secondsInMonth = 31 * secondsInDay; // 31 days
      const secondsInYear = 12 * secondsInMonth;

      let remaining = totalSeconds;
      let years = 0;
      let months = 0;
      let days = 0;
      let hours = 0;
      let minutes = 0;
      let seconds = 0;

      if (remaining >= secondsInYear) {
        years = Math.floor(remaining / secondsInYear);
        remaining %= secondsInYear;
      }

      if (remaining >= secondsInMonth) {
        months = Math.floor(remaining / secondsInMonth);
        remaining %= secondsInMonth;
      }

      if (remaining >= secondsInDay) {
        days = Math.floor(remaining / secondsInDay);
        remaining %= secondsInDay;
      }

      if (remaining >= secondsInHour) {
        hours = Math.floor(remaining / secondsInHour);
        remaining %= secondsInHour;
      }

      if (remaining >= secondsInMinute) {
        minutes = Math.floor(remaining / secondsInMinute);
        remaining %= secondsInMinute;
      }

      seconds = remaining;

      // Decide highest unit to display
      if (years > 0) {
        return `${years}y ${months}mo ${days}d`;
      }

      if (months > 0) {
        return `${months}mo ${days}d ${hours}h`;
      }

      if (days > 0) {
        return `${days}d ${hours}h ${minutes}m`;
      }

      return `${hours}h ${minutes}m ${seconds}s`;
    };
    

export const isAllServiceLineUser = getDataFromLocalStorageParsed("loggedInUser")?.data?.user?.allServiceLineUser;

export const getServiceLinesArray = (isAllServiceLineUser, getSubscribedServiceLines, newSummaryServiceLine) => {
  if (isAllServiceLineUser && getSubscribedServiceLines?.length > 0 && (getSubscribedServiceLines.length - 1) === newSummaryServiceLine?.length) {
    return [];
  }

  if (Array.isArray(newSummaryServiceLine)) {
    return newSummaryServiceLine.filter((sl) => sl !== "");
  }

  return [];
};

export const middleEllipsis = (text = '') => {
  if (!text) return text;
  const keep = 8;
  if (text.length <= keep * 2) return text;
  return `${text.slice(0, keep)}...${text.slice(-keep)}`;
};

  export const formatToReadable = (dateStr: string) => {
    if (!dateStr) return "";

    const date = new Date(dateStr);

    const options: Intl.DateTimeFormatOptions = {
      month: "short",
      day: "2-digit",
      year: "numeric"
    };

    return date.toLocaleDateString("en-US", options);
  };

  export const middleEllipsisByWidth = (text = '', tableWidth = 31) => {
    if (!text) return text;

    if (tableWidth >= 48) return text;

    const minKeep = 8;
    const maxKeep = 14;

    const keep = Math.min(
      maxKeep,
      Math.floor(minKeep + (tableWidth - 31) * 0.5)
    );

    if (text.length <= keep * 2) return text;
    return `${text?.slice(0, keep)}...${text?.slice(-keep)}`;
  };

  export const isParatus = (dpId) =>{
    return dpId === 'DP-0639'
  }

  export const hasLicensePermission = (policy) => {
    const permissions = getDataFromLocalStorage("permissions");
    if (!permissions) return false;

    try {
      const permissionsArray = JSON.parse(permissions);
      if (!Array.isArray(permissionsArray)) return false;

      return permissionsArray.some(service => {
        if (service?.service == 'kapture') {
          const serviceFunctions = service?.servicefunctions || [];
          return serviceFunctions.some(func => func?.function == policy);
        }
      });
    } catch (error) {
      console.error("Error parsing permissions from localStorage:", error);
      return false;
    }
  };

  
/**
     * Compares two software versions and returns TRUE if the current version
     * is LOWER than the threshold version.
     *
     * Both versions can be in forms like:
     *   "v1.1.0.598", "1.1.0.640", etc.
     *
     * How comparison works:
     * 1) Removes leading "v" if present
     * 2) Splits by "." (e.g., "1.1.0.598" → ["1", "1", "0", "598"])
     * 3) Pads each part to at least 2 digits for fair comparison
     *    ("1" → "01", "0" → "00", "598" → "598")
     * 4) Combines into one comparable number string and converts to Number
     * 5) Returns TRUE only if currentVersion < thresholdVersion
     */
    export const isVersionLessThanEqual = (currentVersion, thresholdVersion) => {

      const convert = (version) => {
        let int_version = "";
        const parts = version?.replace(/^v/i, "").split(".");

        parts?.forEach((val, index) => {
          if (index === parts.length - 1) {
            // last segment → 3 digits
            int_version += ("00" + val).slice(-3);
          } else {
            // other segments → 2 digits
            int_version += ("0" + val).slice(-2);
          }
        });

        return Number("1" + int_version);
      };

      return convert(currentVersion) <= convert(thresholdVersion);
    };

export const getReportTableHeaders = (site, sl, Headers, limited_report_access = false) => {
  let headers = [...Headers];

  if (limited_report_access) {
    headers = headers.map((h) =>
      h.key === 'actions' ? { ...h, actions: h.actions.filter((a) => a !== 'delete') } : h,
    );
  }

  // Only site = true → remove Service Lines
  if (site && !sl) {
    return headers.filter(h => h.key !== '_svcLines');
  }

  // Only sl = true → remove Sites
  if (!site && sl) {
    return headers.filter(h => h.key !== '_sites');
  }

  // Otherwise → default
  return headers;
};

export function setDateTimeByTimezone(dateTime: any = null, timezone: any = null) {
  return timezone
    ? moment.tz(dateTime || undefined, timezone)
    : moment(dateTime);
}

const MAX_DAYS_IN_MONTH = 31;
const MAX_WEEKDAY_INDEX = 6;
const ORDINAL_SUFFIXES = ['th', 'st', 'nd', 'rd'];
const WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export function getOrdinalSuffix(value: number): string {
  const v = value % 100;
  return ORDINAL_SUFFIXES[(v - 20) % 10] || ORDINAL_SUFFIXES[v] || ORDINAL_SUFFIXES[0];
}

export function formatRecurringDateUnit(unit: string, value: number): string {
  const intValue = Math.trunc(value);

  if (unit === 'monthly') {
    // 0 represents last day of month; otherwise valid range is 1–31
    if (intValue < 0 || intValue > MAX_DAYS_IN_MONTH) return '';
    if (intValue === 0) return 'Last';
    return `${intValue}${getOrdinalSuffix(intValue)}`;
  }

  if (intValue < 0 || intValue > MAX_WEEKDAY_INDEX) return '';
  return WEEKDAYS[intValue];
}